<template>
  <div class="d-flex col" :class="`col-${cols}`">
    <v-select
      :label="computedLabel"
      :items="[
        { label: config.labelAtivo, value: true },
        { label: config.labelInativo, value: false },
      ]"
      :item-text="'label'"
      :item-value="'value'"
      v-model="value"
      outlined
      dense
    ></v-select>
  </div>
</template>

<script>
export default {
  name: "AtivoSelectComponent",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    cols: {
      type: Number,
      default: 12,
    },
    config: {
      type: Object,
      default: () => ({
        labelAtivo: "Ativo",
        labelInativo: "Inativo",
        label: "Ativo",
      }),
    },
    labelType: {
      type: String,
      default: "Ativo",
      validator: (value) => ["Ativo", "Situação"].includes(value),
    },
  },
  computed: {
    computedLabel() {
      return this.labelType === "Situação" ? "Situação" : this.config.label;
    },
  },
  watch: {
    value(v) {
      this.$emit("input", v);
    },
  },
};
</script>